import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Label, Row, Col, Table, InputGroup, InputGroupAddon, InputGroupText, Input, FormGroup } from 'reactstrap';
import { Translate, Storage, translate, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { createEntity, reset } from 'app/entities/order/order.reducer';
import { IRootState } from 'app/shared/reducers';
import OrderBreadCrumb from '../order-breadcrumb';
import { convertToDisplay, convertToDisplayWithTime } from 'app/shared/util/date-utils';
import { defaultEventTypes, IEvent, IEventTypes } from 'app/shared/model/event.model';
import { DeliverType } from 'app/shared/model/order.model';
import { IZone } from 'app/shared/model/zone.model';
import { ISession } from 'app/shared/model/session.model';
import { IPricing, TicketType } from 'app/shared/model/pricing.model';
import { isIgnoreZoneSeat } from 'app/modules/order/order-shared';

export interface ISeatSelectionProps extends StateProps, DispatchProps, RouteComponentProps<{ eventId: string }> {}

export interface ISeatSelectionState {
  event: IEvent;
  session: ISession;
  zone: IZone;
  pricing: IPricing;
  numTicket: number;
  cSelected: object;
  ticketNum: object;
  option: number;
  zoneImgUrl: string;
  isAddedToCart: boolean;
  deliverType: DeliverType;
  cart: any[];
}

export class SeatSelection extends React.Component<ISeatSelectionProps, ISeatSelectionState> {
  state: ISeatSelectionState = {
    event: { sessions: [], pricings: [], site: { name: '' }, seatingPlanUrl: '' },
    session: {},
    option: 0,
    zone: { id: 0 },
    pricing: { id: 0 },
    numTicket: 0,
    cSelected: [],
    ticketNum: { a: 0, b: 0 },
    zoneImgUrl: '',
    isAddedToCart: false,
    deliverType: DeliverType.NONE,
    cart: []
  };

  constructor(props) {
    super(props);
    this.onZoneBtnClick = this.onZoneBtnClick.bind(this);
    this.onNumTicketBtnClick = this.onNumTicketBtnClick.bind(this);
    this.onOptionBtnClick = this.onOptionBtnClick.bind(this);
  }

  componentDidMount() {
    const event = Storage.session.get('EVENT');
    const session = Storage.session.get('SESSION');
    if (event != null && session != null) {
      this.setState({ event, session, zoneImgUrl: event.seatingPlanUrl });
      // set default to delivery if there is only delivery
      if (event.types && event.types !== '') {
        const eventTypes: IEventTypes = JSON.parse(event.types);
        const noOnsite = !(typeof eventTypes.deliveryChargeOnsite !== 'undefined' && eventTypes.deliveryChargeOnsite === 0);
        if (eventTypes.deliveryChargeHk && !eventTypes.deliveryChargeMacau && noOnsite) {
          this.setState({ deliverType: DeliverType.DELIVERY_HK });
        } else if (!eventTypes.deliveryChargeHk && eventTypes.deliveryChargeMacau && noOnsite) {
          this.setState({ deliverType: DeliverType.DELIVERY_MACAU });
        } else if (!eventTypes.deliveryChargeHk && !eventTypes.deliveryChargeMacau && !noOnsite) {
          this.setState({ deliverType: DeliverType.DELIVERY_ONSITE });
        }
      }
    }
    const cart = Storage.session.get('CART');
    if (cart && cart.length > 0) this.setState({ isAddedToCart: true });
    this.setState({ cart: Storage.session.get('CART') || [] });
  }

  componentDidUpdate() {
    if (this.props.updateSuccess) this.props.history.push('/order/personal-info');
  }

  componentWillUnmount() {
    this.props.reset();
  }

  onZoneBtnClick(pricing: IPricing) {
    const zone = pricing.zone;
    if (this.state.zone.id === pricing.zone.id) {
      this.setState({ pricing: { id: 0 } });
      this.setState({ zone: { id: 0 } });
      this.setState({ zoneImgUrl: Storage.session.get('EVENT').seatingPlanUrl });
    } else {
      this.setState({ pricing });
      this.setState({ zone });
      if (zone.imageUrl && zone.imageUrl !== '') this.setState({ zoneImgUrl: zone.imageUrl });
    }
  }

  onNumTicketBtnClick(numTicket) {
    this.setState({ numTicket });
  }

  onOptionBtnClick(option) {
    this.setState({ option });
  }

  addToCartBtnClick = () => {
    const cart = this.state.cart;
    const order = cart.find(
      o => o.pricing.id === this.state.pricing.id && o.zone.id === this.state.zone.id && o.session.id === this.state.session.id
    );
    if (order) {
      order.numTicket += this.state.numTicket;
    } else {
      cart.push({
        session: Storage.session.get('SESSION'),
        pricing: this.state.pricing,
        zone: this.state.zone,
        numTicket: this.state.numTicket
      });
    }
    Storage.session.set('CART', cart);
    this.setState({ cart, isAddedToCart: true });
  };

  deleteBtnClick = i => {
    const cart = this.state.cart;
    cart.splice(i, 1);
    Storage.session.set('CART', cart);
    this.setState({ cart });
    // enable buttons again
    if (cart.length === 0) this.setState({ cart, isAddedToCart: false });
  };

  onNextStepBtnClick() {
    const event = Storage.session.get('EVENT');
    const orderToken = Storage.session.get('ORDER_TOKEN');
    const data = {
      eventId: event.id,
      siteId: event.site.id,
      token: orderToken.token,
      deliverType: this.state.deliverType,
      orderDetails: []
    };
    this.state.cart.forEach(order =>
      data.orderDetails.push({
        sessionId: order.session.id,
        pricingId: order.pricing.id,
        zoneId: order.zone.id,
        ticketNumber: order.numTicket
      })
    );
    this.props.createEntity(data);
  }

  onOrderOthersBtnClick = () => {
    this.props.history.push('/order/date-selection');
  };

  /*
  onCheckboxBtnClick(selected) {
      const index = this.state.cSelected.indexOf(selected);
      if (index < 0) {
        this.state.cSelected.push(selected);
      } else {
        this.state.cSelected.splice(index, 1);
      }
      this.setState({ cSelected: [ ...this.state.cSelected ] });
    }
    onZoneRadioClick = zoneId => {
      this.form.reset();
      this.setState({ zoneId });
    };

    onZoneChanged = e => {
      this.setState({
        zoneId: e.currentTarget.value,
        ticketNum: { a: 0, b: 0 }
      });
    };
    */

  render() {
    const { event, isAddedToCart, cart } = this.state;
    const eventTypes: IEventTypes = event.types && event.types !== '' ? JSON.parse(event.types) : defaultEventTypes;
    const deliveryChargeHk = eventTypes.deliveryChargeHk;
    const deliveryChargeMacau = eventTypes.deliveryChargeMacau;
    const deliveryChargeOnsite = eventTypes.deliveryChargeOnsite;
    const pricings: IPricing[] = [];
    event.pricings.forEach(p => {
      if (!pricings.find(pricing => pricing.id === p.id) && p.ticketType === TicketType.PUBLIC) {
        pricings.push(p);
      }
    });
    const zoneButtons = pricings.map(p => (
      <Button
        key={p.id}
        color="secondary"
        size="lg m-2"
        onClick={() => this.onZoneBtnClick(p)}
        active={this.state.pricing.id === p.id}
        disabled={this.state.isAddedToCart}
      >
        {this.state.pricing.id === p.id ? <FontAwesomeIcon icon="check" /> : ''}
        {!isIgnoreZoneSeat(event) && p.zone.name + ' / '} HKD {p.price} {p.remark ? p.remark : ''}
      </Button>
    ));
    const numTicketBought = () => cart.map(c => c.numTicket).reduce((a, b) => a + b, 0);
    const isTicketNumOverTotal = () => numTicketBought() > event.maxTicketsPerOrder;
    const isNextButtonDisabled = () =>
      isTicketNumOverTotal() || (eventTypes.type === 'ticketDelivery' && this.state.deliverType === DeliverType.NONE) || this.props.loading;
    // const isShowOrderInfo = () => cart && cart.length > 0 && this.state.zone.id !== 0 && this.state.numTicket !== 0;

    const renderTicketButtons = maxTicketsPerOrder => {
      const rows = [];
      for (let i = 1; i < maxTicketsPerOrder + 1; i++) {
        const n = i;
        rows.push(
          <Button
            color="secondary"
            size="lg m-2"
            onClick={() => this.onNumTicketBtnClick(n)}
            active={this.state.numTicket === n}
            key={n}
            disabled={this.state.isAddedToCart}
          >
            {this.state.numTicket === n ? <FontAwesomeIcon icon="check" /> : ''} {n}
          </Button>
        );
      }
      return <>{rows}</>;
    };

    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <OrderBreadCrumb step="2" currentLocale={this.props.currentLocale} />
          <Row className="justify-content-center">
            <Col md="12" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.seatselection.selectzone">請選擇票價</Translate>
              </h2>
            </Col>
            {this.state.zoneImgUrl && this.state.zoneImgUrl !== '' ? (
              <>
                <Col md="6" className="text-center mt-3">
                  <h3>
                    <Translate contentKey="order.seatselection.zonemap">Zone Map</Translate>
                  </h3>
                  <a target="_blank" href={this.state.zoneImgUrl}>
                    <img src={this.state.zoneImgUrl} className="img-fluid" />
                  </a>
                </Col>
                <Col md="6" className="text-center mt-3 justify-content-center align-self-center">
                  {zoneButtons}
                </Col>
              </>
            ) : (
              <Col md="12" className="text-center mt-3">
                {zoneButtons}
              </Col>
            )}
          </Row>
          <Row className="justify-content-center mt-3">
            {/*<Col md="6" className="text-center mt-3">
            <AvForm ref={c => (this.form = c)}>
              <Table hover>
                <thead>
                <tr>
                  <th></th>
                  <th>區域</th>
                  <th>價錢(HKD)</th>
                  <th>數目</th>
                </tr>
                </thead>
                <tbody>
                <tr onClick={() => this.onZoneRadioClick(1)}>
                  <th scope="row"><AvField type="radio" name="zone" value="1" onChange={this.onZoneChanged} required checked={this.state.zone.id == 1}/></th>
                  <td>A</td>
                  <td>$780</td>
                  <td>
                    <Col md="6" className="justify-content-center">
                    <AvField type="number" name="ticketNum1"  step="1" min="0" max="8" className="form-control" placeholder="數目"/>
                    </Col>
                  </td>
                </tr>
                <tr onClick={() => this.onZoneRadioClick(2)}>
                  <th scope="row"><AvField type="radio" name="zone" value="2" onChange={this.onZoneChanged} required checked={this.state.zone.id == 2}/></th>
                  <td>B</td>
                  <td>$560</td>
                  <td>
                    <Col md="6" className="justify-content-center">
                      <AvField type="number" name="ticketNum2" step="1" min="0" max="8" className="form-control" placeholder="數目"/>
                    </Col>
                  </td>
                </tr>
                </tbody>
              </Table>
            </AvForm>
          </Col>*/}
          </Row>
          <Row className="justify-content-center mt-4">
            <Col md="12" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.seatselection.ticketnumber">購票數目</Translate>
              </h2>
            </Col>
            <Col md="10" className="text-center mt-4 mb-4">
              {renderTicketButtons(event.maxTicketsPerOrder)}
            </Col>
            {!isAddedToCart && (
              <Col md="12" className="text-center">
                <p>
                  <Translate contentKey="order.seatselection.note1">請選擇票數後往下一步</Translate>
                </p>
                <Button
                  className="mt-4"
                  color="primary"
                  size="xlg"
                  onClick={this.addToCartBtnClick}
                  disabled={this.state.zone.id === 0 || this.state.numTicket === 0}
                >
                  <Translate contentKey="order.nextstep">下一步</Translate>
                </Button>
              </Col>
            )}
          </Row>
          <Row className="justify-content-center mt-4 mb-4">
            {/*<Col md="12" className="text-center bg-primary">
            <h2 className="mt-3 mb-3 text-light">自動分配選項</h2>
          </Col>
          <Col md="10" className="text-center mt-4">
            <Button color="secondary" size="lg m-2" onClick={() => this.onOptionBtnClick(1)} active={this.state.option === 0}>
              {this.state.option === 0 ? <FontAwesomeIcon icon="check"/> : ''} 無
            </Button>
            <Button color="secondary" size="lg m-2" onClick={() => this.onOptionBtnClick(1)} active={this.state.option === 1}>
              {this.state.option === 1 ? <FontAwesomeIcon icon="check"/> : ''} 路口
            </Button>
            <Button color="secondary" size="lg m-2" onClick={() => this.onOptionBtnClick(2)} active={this.state.option === 2}>
              {this.state.option === 2 ? <FontAwesomeIcon icon="check"/> : ''} 傷殘人事座位
            </Button>
          </Col>*/}
            {isAddedToCart && (
              <>
                <Col md="12" className="text-center bg-primary">
                  <h2 className="mt-3 mb-3 text-light">
                    <Translate contentKey="order.seatselection.orderinfo">Order Info</Translate>
                  </h2>
                </Col>
                <Col>
                  <Table hover>
                    <thead>
                      <tr>
                        <th>
                          <Translate contentKey="order.seatselection.session">Session</Translate>
                        </th>
                        {!isIgnoreZoneSeat(event) && (
                          <th>
                            <Translate contentKey="order.seatselection.zone">zone</Translate>
                          </th>
                        )}
                        <th>
                          <Translate contentKey="order.seatselection.price">price</Translate>
                        </th>
                        <th>
                          <Translate contentKey="order.seatselection.numticket">Number of Tickets</Translate>
                        </th>
                        <th />
                      </tr>
                    </thead>
                    {cart &&
                      cart.length > 0 && (
                        <tbody>
                          {cart.map((c, i) => (
                            <tr key={i}>
                              <td>{convertToDisplayWithTime(c.session.startTime)}</td>
                              {!isIgnoreZoneSeat(event) && <td>{c.zone.name}</td>}
                              <td>
                                HKD{c.pricing.price} {c.pricing.remark ? c.pricing.remark : ''}
                              </td>
                              <td>{c.numTicket}</td>
                              <td onClick={this.deleteBtnClick}>
                                <FontAwesomeIcon className="text-danger hand" icon="trash" />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                  </Table>
                </Col>
                <Col md="12" className="text-center mt-3">
                  {isTicketNumOverTotal() && (
                    <p className="text-danger">
                      <Translate
                        contentKey="order.seatselection.toomanytickets"
                        interpolate={{ maxTicketsPerOrder: event.maxTicketsPerOrder }}
                      >
                        購票總數超過 {event.maxTicketsPerOrder} 張，請删減部份場次
                      </Translate>
                    </p>
                  )}
                  {eventTypes.type === 'ticketDelivery' && (
                    <FormGroup tag="fieldset">
                      <FormGroup check>
                        {/*<Label check className="mr-5">
                          <Translate contentKey="order.seatselection.getticket">Get ticket</Translate>:
                        </Label>*/}
                        {/*{eventTypes.minTicket >= numTicketBought() && (
                          <Label check className="mr-5">
                            <Input
                              type="radio"
                              name="deliverType"
                              checked={this.state.deliverType === DeliverType.FLAT}
                              onClick={() => this.setState({ deliverType: DeliverType.FLAT })}
                            />{' '}
                            <Translate contentKey="order.seatselection.deliverticket">Flat Deliver ticket</Translate>
                          </Label>
                        )}*/}
                        {deliveryChargeHk && (
                          <Label className="mr-5">
                            <Input
                              type="radio"
                              name="deliverType"
                              checked={this.state.deliverType === DeliverType.DELIVERY_HK}
                              onClick={() => this.setState({ deliverType: DeliverType.DELIVERY_HK })}
                            />{' '}
                            <Translate contentKey="order.seatselection.deliverticketcharge_hk" interpolate={{ deliveryChargeHk }}>
                              Deliver ticket HK
                            </Translate>
                          </Label>
                        )}

                        {deliveryChargeMacau && (
                          <Label className="mr-5">
                            <Input
                              type="radio"
                              name="deliverType"
                              checked={this.state.deliverType === DeliverType.DELIVERY_MACAU}
                              onClick={() => this.setState({ deliverType: DeliverType.DELIVERY_MACAU })}
                            />{' '}
                            <Translate contentKey="order.seatselection.deliverticketcharge_macau" interpolate={{ deliveryChargeMacau }}>
                              Deliver ticket Macau
                            </Translate>
                          </Label>
                        )}

                        {deliveryChargeOnsite !== undefined && (
                          <Label>
                            <Input
                              type="radio"
                              name="deliverType"
                              checked={this.state.deliverType === DeliverType.DELIVERY_ONSITE}
                              onClick={() => this.setState({ deliverType: DeliverType.DELIVERY_ONSITE })}
                            />{' '}
                            <Translate contentKey="order.seatselection.deliverticketcharge_onsite" interpolate={{ deliveryChargeOnsite }}>
                              collect ticket
                            </Translate>
                          </Label>
                        )}
                      </FormGroup>
                    </FormGroup>
                  )}
                  <Button
                    className="mt-4"
                    color="primary"
                    size="xlg"
                    onClick={() => this.onNextStepBtnClick()}
                    disabled={isNextButtonDisabled()}
                  >
                    <Translate contentKey="order.nextstep">NEXT</Translate>
                  </Button>
                </Col>
                {/*<Col md="12" className="text-center mt-3">
                  <Button className="mt-4" color="secondary" size="xlg" onClick={this.onOrderOthersBtnClick}>
                    <Translate contentKey="order.seatselection.orderothers">Order others</Translate>
                  </Button>
                </Col>*/}
              </>
            )}
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  loading: storeState.order.loading,
  updating: storeState.order.updating,
  updateSuccess: storeState.order.updateSuccess,
  currentLocale: storeState.locale.currentLocale
});

const mapDispatchToProps = { createEntity, reset };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SeatSelection);
